export default {"src":"/_next/static/media/globalCover_24.60e8c361.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};